import React from "react";

export function SuppliesHeader({
                                   onCreateType,
                                   onCreateTemplate,
                                   onCreateScheduled,
                                   onScrollTypes,
                                   onScrollTemplates,
                                   onScrollScheduled,
                                   onScrollCurrent,
                               }: {
    onCreateType: () => void;
    onCreateTemplate: () => void;
    onCreateScheduled: () => void;
    onScrollTypes: () => void;
    onScrollTemplates: () => void;
    onScrollScheduled: () => void;
    onScrollCurrent: () => void;
}) {
    return (
        <>
            <div className="supplies-header" style={{ gap: 10, flexWrap: "wrap" }}>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onCreateType}>
                    + Добавить тип
                </button>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onCreateTemplate}>
                    + Добавить шаблон
                </button>

                <button className="admin-button-primary" onClick={onCreateScheduled}>
                    + Добавить планируемую (из шаблона)
                </button>
            </div>

            <div className="supplies-header" style={{ gap: 10, flexWrap: "wrap", marginTop: 12 }}>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onScrollTypes}>
                    К типам
                </button>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onScrollTemplates}>
                    К шаблонам
                </button>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onScrollScheduled}>
                    К планируемым
                </button>
                <button className="admin-button-secondary admin-button-secondary--ghost" onClick={onScrollCurrent}>
                    К текущим
                </button>
            </div>
        </>
    );
}
